export default __webpack_public_path__ + "static/media/api_Image.465f9643.png";